import React from 'react'
import { LucideIcon } from 'lucide-react'

export interface SettingsGroupSection {
  icon: LucideIcon
  title: string
  description: string
  action: React.ReactNode
}

export interface SettingsGroupProps {
  sections: SettingsGroupSection[]
  className?: string
}

/**
 * A list of settings rows — icon, title, description, action — divided inside
 * one card. Its frame uses the same `bg-card` / `border-border` tokens as
 * `FormSection` so a page can mix the two: the Security tabs put this beside
 * five FormSections, and the literal `bg-white dark:bg-gray-900` it used
 * before was a near-miss of the card token rather than a match.
 */
export function SettingsGroup({ sections, className = '' }: SettingsGroupProps) {
  return (
    <div className={`bg-card rounded-lg border border-border overflow-hidden ${className}`}>
      {sections.map((section, index) => (
        <React.Fragment key={index}>
          <div className="flex items-start justify-between p-4">
            <div className="flex items-start gap-3">
              <section.icon className="h-4 w-4 text-muted-foreground mt-1.5" />
              <div>
                <h4 className="font-medium">{section.title}</h4>
                <p className="text-sm text-muted-foreground">
                  {section.description}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              {section.action}
            </div>
          </div>
          {index < sections.length - 1 && (
            <div className="border-t border-border ml-12"></div>
          )}
        </React.Fragment>
      ))}
    </div>
  )
}

export default SettingsGroup 